import React, { memo } from 'react';
import { Space } from '@redlink/components/atoms';
import { FormSection } from '@redlink/components/molecules';
import { LinkTemplateListItem } from '@redlink/components/molecules';
import { Fragment } from 'react';

export const LinkTemplateList = memo(({ data = [], title, onChange }) => {
  return (
    <FormSection {...{ title }}>
      {data.map((item, index) => {
        return (
          <Fragment key={`${item.prefix}-${index}`}>
            <LinkTemplateListItem
              updateFlag={item.value?.raw}
              {...{ item, index }}
              onAdd={(old, value) => {
                const updatedList = [...data];
                updatedList.splice(index, 1, ...[old, value]);
                onChange(updatedList);
              }}
              onChange={(value) => {
                const updatedList = [...data];
                updatedList.splice(index, 1, value);
                onChange([...updatedList]);
              }}
              onRemove={() => {
                const updatedList = [...data];
                updatedList.splice(index, 1);
                onChange([...updatedList]);
              }}
            />
            <Space size={8} />
          </Fragment>
        );
      })}
      <Space />
    </FormSection>
  );
});
